// "Powered by" footer used on the auth screens. For client tenants it shows
// two lines: the client brand (plain text) plus the Locate2u line linking to
// the marketing site (opens in a new tab). When the brand IS Locate2u, only
// the linked line renders so the text doesn't repeat. Centralised here so the
// link can never drift across the auth pages.
export function PoweredByFooter({ brandName }: { brandName: string }) {
  const isLocate2u = brandName.trim().toLowerCase() === 'locate2u';
  return (
    <div className="space-y-0.5 text-[10px] uppercase tracking-[0.2em] text-slate-500">
      {!isLocate2u && <div>Powered by {brandName}</div>}
      <div>
        Powered by{' '}
        <a
          href="https://www.locate2u.com"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          Locate2u
        </a>
      </div>
    </div>
  );
}
